import { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';

export const inputtext: InputTextDesignTokens = {
  root: {
    paddingX: '10px',
    paddingY: '10px',
    borderRadius: '8px',
  },
  colorScheme: {
    dark: {
      root: {
        borderColor: '{content.borderColor}',
        hoverBorderColor: '{surface.0}',
        filledBackground: '{blue.400}',
        filledFocusBackground: '{blue.500}',
      },
    },
  },
};
